export const getEnumKeys = <T extends object>(enumObj: T): (keyof T)[] => {
    return Object.keys(enumObj).filter(key => isNaN(Number(key))) as (keyof T)[];
}

export const getEnumValues = <T extends object>(enumObj: T): T[keyof T][] => {
    return Object.values(enumObj);
};
